/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/irate.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Calculates the per-second instant rate of increase based on the last two data points. Requires a counter input; non-counter inputs are automatically coerced with `to_counter`. The metric\'s configured temporality (cumulative or delta) is honored. The result is always a `double`.',
  examples: [
    'irate(http_requests_total[5m])',
  ],
};

export default docs;
